import { createContext, useContext, useMemo, useState } from "react";

const SimContext = createContext(null);

export const SimProvider = ({ children }) => {
  const [patient, setPatient] = useState(null);
  const [plan, setPlan] = useState(null);
  const [activeSim, setActiveSim] = useState(null); // 'anaesthesia' | 'fluidpump'

  const value = useMemo(() => {
    const reset = () => {
      setPatient(null);
      setPlan(null);
    };
    return { patient, setPatient, plan, setPlan, activeSim, setActiveSim, reset };
  }, [patient, plan, activeSim]);

  return <SimContext.Provider value={value}>{children}</SimContext.Provider>;
};

export const useSim = () => {
  const ctx = useContext(SimContext);
  if (!ctx) throw new Error("useSim must be used within SimProvider");
  return ctx;
};
